import React, { useEffect, useState } from "react";
import TimeSpentModal from "../../utils/TimeSpentModal";
import { useParams } from "react-router-dom";
import { useGetCatalogReportKeyData } from "../../CatalogReport/hooks/useGetCatalogReportKeyData";
import { useGetCatalogClientAllEmpReportKeyData } from "../hooks/useGetCatalogClientAllEmpReportKeyData";

const findModalHeading = (productDetails, type) => {
  const heading = {
    view: {
      mainHeading: `Total Views on ${productDetails?.styleNumber}`,
      title: "Total View By Each Employee",
      totalCountTitle: "Total View",
    },

    cart: {
      mainHeading: `Total Orders of ${productDetails?.styleNumber}`,
      title: "Total Order By Each Employee",
      totalCountTitle: "Total Orders",
    },

    removeCart: {
      mainHeading: `Total Cart Removal of ${productDetails?.styleNumber}`,
      title: "Total Cart Removal By Each Employee",
      totalCountTitle: "Total Cart Removal",
    },
    clock: {
      mainHeading: `Total Time Spent on ${productDetails?.styleNumber}`,
      title: "Total Time Spent By Each Employee",
      totalCountTitle: `Total Time Spent on ${productDetails?.styleNumber}`,
    },
  };

  return heading[type];
};

const CatalogClientViewCartModal = ({ open, setOpen, productDetails, viewCartType }) => {
  const { id } = useParams();
  const [totalData, setTotalData] = useState([]);
  const [headings, setHeadings] = useState({});

  let companyName = new URLSearchParams(window?.location?.search).get("companyName");

  const {
    data,
    isLoading: timeIsLoding,
    isError: timeIsError,
    error: timeError,
    hasNextPage,
    fetchNextPage,
    isFetchNextPage,
    isFetching,
  } = useGetCatalogClientAllEmpReportKeyData({ catalogId: id, styleId: productDetails?._id, key: viewCartType ? viewCartType : "view", companyName: companyName });

  useEffect(() => {
    setHeadings(findModalHeading(productDetails, viewCartType));
  }, [productDetails, viewCartType, id]);

  return (
    <TimeSpentModal
      open={open}
      setOpen={setOpen}
      data={data || []}
      timeIsLoding={timeIsLoding}
      timeIsError={timeIsError}
      timeError={timeError}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchNextPage={isFetchNextPage}
      isFetching={isFetching}
      title={headings?.title}
      mainHeading={headings?.mainHeading}
      totalCountTitle={headings?.totalCountTitle}
      viewCartType={viewCartType || ""}
    />
  );
};

export default CatalogClientViewCartModal;
